import { axiosPost } from "../../../../../../packages/apiPackage/axiosRequest";
import ApiConstants from "../../../../../../utils/apiConstants";

async function CreateBusinessIdea({ setBtnLoading, btnLoading, editionId,
    profilePic, title, description }) {

    if (!btnLoading) {
        setBtnLoading(true);
        try {
            var response = await axiosPost({
                endpoint: ApiConstants.CREATE_PE_BUSINESS_IDEA,
                jsonBody: JSON.stringify({
                    editionId: editionId,
                    title: title,
                    description: description
                })
            })

            console.log("response = ", response)
            const businessId = response.data.speaker._id;
            console.log("businessId = ", businessId)

            //upload pic here...
            if (profilePic) {
                const formData = new FormData();
                formData.append('file', profilePic);

                let res = await axiosPost({
                    endpoint: `${ApiConstants.UPLOAD_PE_PIC}/${businessId}`,
                    formData: formData
                })
                console.log('File uploaded successfully! = ', res);
            }
            // console.log("response = ", response);
            setBtnLoading(false);
            return true;
        } catch (error) {
            console.log("error = ", error)
            setBtnLoading(false);
            if (!error?.response) {
                console.log("No server response.");
                // console.log("Login credit Expired.\nPlease Login Again!!!");
            } else if (error.response?.status === 404 || error.response?.status === 401) {
                console.log("Server Error !!! Try Logging in again.");
            } else {
                console.log("Login credit Expired.\nPlease Login Again!!!");
            }
            return false;
        }
    }
}

export default CreateBusinessIdea;